import api from './api'

export default {
  // 图片oss
  'img_oss'(oss, key) {
    return oss ? api.imgUrl + oss + '?x-oss-process=style/' + (key || 'tubo_tiny') : ''
  },
  // 货币
  'currency'(val, key) {
    return (key || '￥') + (val || 0).toFixed(2)
  }

}